import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Impressum = () => {
  return (
    <div className="min-h-screen bg-[#F5F1E8]">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <Link
            to="/"
            className="inline-flex items-center text-[#2C5F7C] hover:text-[#1e4a63] transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Zurück zur Startseite
          </Link>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-[#2C5F7C] mb-8">Impressum</h1>

        <div className="bg-white rounded-lg shadow-md p-8 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              Angaben gemäß § 5 TMG
            </h2>
            <p className="text-gray-700 leading-relaxed">
              <strong>Wahr Privatinstitut für Dialog und Markenkompetenz UG</strong>
              <br />
              Mittelstraße 11
              <br />
              40789 Monheim am Rhein
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              Vertreten durch
            </h2>
            <p className="text-gray-700">
              Geschäftsführer: Nicolas Alexander Wahr
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              Kontakt
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Telefon: 0174 6429886
              <br />
              E-Mail:{" "}
              <a
                href="mailto:Nicolas.wahr@icloud.com"
                className="text-[#87CEEB] hover:underline"
              >
                Nicolas.wahr@icloud.com
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              Registereintrag
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Eintragung im Handelsregister
              <br />
              Registergericht: Amtsgericht Düsseldorf
              <br />
              Registernummer: HRB 110791
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              Umsatzsteuer-ID
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
              <br />
              DE458175775
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Nicolas Alexander Wahr
              <br />
              Mittelstraße 11
              <br />
              40789 Monheim am Rhein
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              EU-Streitschlichtung
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#87CEEB] hover:underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              <br />
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              Verbraucherstreitbeilegung/Universalschlichtungsstelle
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
              vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
